import Link from "next/link";

function StockDetailLink({
  children,
  ticker,
  className,
  dataGtmId,
}: {
  children: React.ReactNode;
  ticker: string;
  className?: string;
  dataGtmId?: string;
}) {
  return (
    <Link
      href={`/detail/${ticker}`}
      className={className}
      data-gtm-id={dataGtmId}
    >
      {children}
    </Link>
  );
}

export default StockDetailLink;
